import React from 'react'
import { Box, Divider, IconButton, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import ShareThis from '../../../_common/ShareThis';
// import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import ChartItem from '../../../_common/Skeleton/chart';
import dynamic from 'next/dynamic';
const D3Chart = dynamic(() => import('../../../_common/D3Chart'),
  { loading: () => <ChartItem /> })
// import Clipboard from '../../../_common/Clipboard';
import { dataConstants } from '../../../../constants';
import { getRandomStr, getTabData } from '../../../../helpers';
// import { getChartSeriesColor } from '../../../../utils';
// import CloseFullscreenRoundedIcon from '@mui/icons-material/CloseFullscreenRounded';
import CollapseCard from '../../CollapseCard';

const { ECO_SECTION_CODES } = dataConstants || {};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  '&:hover button, .share-wrapper': {
    visibility: 'visible'
  },
  '& .Item-Head': {
    background: '#f2f2f2',
    borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: '4px 4px 0 0',
    '& a': {
      textDecoration: 'none',
      color: '#333',
      fontWeight: 600,
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '.option-desc .MuiTypography-caption': {
    color: "#333 !important",
  },
  '& .option-content .option-desc': {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  '& button, .share-wrapper': {
    visibility: 'hidden'
  },
  '& .MuiGrid-root': {
    width: '100% !important',
    margin: 0,
  },
  '& .MuiGrid-root > .MuiGrid-item': {
    padding: 0,
    marginLeft: 0,
    marginRight: 0,
  },
}));

function HistoricalGDPGrowth({ data, gdata, themes, onChangeInfo, handleClick, getChartData, selectedInfo }) {

  //gdp history pct chart
  const gdpHistPct = data && data.find(d => d.section_code === ECO_SECTION_CODES.GDP_HIST_PCT) ? data.find(d => d.section_code === ECO_SECTION_CODES.GDP_HIST_PCT) : undefined;
  const gdpHistPctChart = gdpHistPct && gdpHistPct.tabData ? getChartData(gdpHistPct.tabData, getTabData(gdata, gdpHistPct, ECO_SECTION_CODES.GDP_BREAK)) : undefined;

  return (
    <>
      {gdpHistPct &&
        <Item component="div" className="col-md-4" sx={{ mb: 1.5 }}>
          <Box
            className="Item-Head"
            sx={{
              display: 'flex',
              alignItems: 'center',
              px: 0.5,
            }}
          >
            <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
              {gdpHistPct.section_name}
            </Typography>
            {/* <IconButton aria-label="info" onClick={() => onChangeInfo(gdpHistPct.section_code)}>
              <InfoRoundedIcon size="small" sx={{ fontSize: '1.1rem', color: 'text.link' }} />
            </IconButton> */}
            <ShareThis
              link={encodeURI(`${process.env.NEXT_PUBLIC_URL}${dataConstants.NAVS.CHART_SHARE}/${gdpHistPctChart?.code}/${gdpHistPctChart?.series.map(d => d.yformula).join(';')}/${gdpHistPct.section_name}`)}
              title={`${gdpHistPct.section_name}`}
              message={`${gdpHistPct.section_name}`}
              subject={''}
            />
          </Box>
          {gdpHistPctChart && gdpHistPctChart.description && <Box sx={{ m: 1, px: 2 }} component="div" className="option-desc"><Typography variant="caption" sx={{ fontSize: '.875rem' }} dangerouslySetInnerHTML={{ __html: gdpHistPctChart.description }} /></Box>}
          <Box component="div" className="option-content eco-chart" sx={{ position: 'relative', px: 2, minHeight: { md: '13rem', xs: '10rem' } }}>
            <D3Chart
              showChart={true}
              noHeader
              // maxHeight={chartProps.maxHeight}
              scale={1}
              // onClick={code => handleClick(code)}
              chart={{ ...gdpHistPctChart, id: gdpHistPct.section_code, tick: 2 }}
              // userName={`@${chart.code.split('@')[1]}`}
              themes={themes}
              type={dataConstants.CHART_STATE.VIEW}
              // axisTextMargin={chartProps.axisTextMargin}
              chartMargin={{ left: 40, bottom: 48 }}
              axisTextMargin={{ y: 96 }}
              // wrapperClass="StockCardImage"
              showLegend={false}
              showCrosshair
            />
          </Box>
          <CollapseCard
            selectedInfo={selectedInfo}
            section_code={gdpHistPct?.section_code}
            chart_codes={gdpHistPctChart}
            handleClick={handleClick}
            height={'32vh'}
          />
        </Item>}
    </>
  )
}

export default HistoricalGDPGrowth
